/**
 * configurator API
 * configurator API documentation
 *
 * OpenAPI spec version: 0.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import {Inject, Injectable, Optional} from '@angular/core';
import { HttpClient, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import {CustomHttpUrlEncodingCodec} from '../encoder';

import {Observable} from 'rxjs';

import { DatastoreAdminDto } from '../model/datastoreAdminDto';
import { DatastoreDto } from '../model/datastoreDto';
import { FieldTableDto } from '../model/fieldTableDto';
import { TableDto } from '../model/tableDto';
import { TableLiteDto } from '../model/tableLiteDto';
import { TablesAcessDTO } from '../model/tablesAcessDTO';
import { ImportZipBody } from '../model/importZipBody';

import {BASE_PATH} from '../variables';
import {Configuration} from '../configuration';


@Injectable()
export class ConfiguratorStructureService {

    protected basePath = 'https://dmp.airiane.com/services/configurator';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }

    /**
     * Ajouter la gestion des versioning
     * Ajoute les champs et les triggers
     * @param xDataStoreID
     * @param codeTable
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public addVersioning(xDataStoreID: string, codeTable?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public addVersioning(xDataStoreID: string, codeTable?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public addVersioning(xDataStoreID: string, codeTable?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public addVersioning(xDataStoreID: string, codeTable?: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling addVersioning.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (codeTable !== undefined && codeTable !== null) {
            queryParameters = queryParameters.set('codeTable', <any> codeTable);
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [];

        return this.httpClient.request<any>('post', `${this.basePath}/api/structure/table/versioning`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Créer un nouveau datastore
     * Cette requête permet de créer un nouveau datastore et renvoie le datastore créé. (code 201)&lt;br&gt;Si le datastore a un identifiant, une erreur est renvoyée. (code 400)
     * @param datastoreDto datastoreDto
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createDatastoreUsingPOST1(datastoreDto: DatastoreAdminDto, observe?: 'body', reportProgress?: boolean): Observable<DatastoreAdminDto>;
    public createDatastoreUsingPOST1(datastoreDto: DatastoreAdminDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DatastoreAdminDto>>;
    public createDatastoreUsingPOST1(datastoreDto: DatastoreAdminDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DatastoreAdminDto>>;
    public createDatastoreUsingPOST1(datastoreDto: DatastoreAdminDto, observe: any = 'body', reportProgress = false): Observable<any> {

        if (datastoreDto === null || datastoreDto === undefined) {
            throw new Error('Required parameter datastoreDto was null or undefined when calling createDatastoreUsingPOST1.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<DatastoreAdminDto>(`${this.basePath}/api/structure/datastores`,
            datastoreDto,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Ajouter un champ à une table
     * Cette requête permet d&#39;ajouter un champ à une table.
     * @param xDataStoreID X-DataStoreID
     * @param field field
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createFieldUsingPOST(xDataStoreID: string, field: FieldTableDto, partnerId?: string, observe?: 'body', reportProgress?: boolean): Observable<TableLiteDto>;
    public createFieldUsingPOST(xDataStoreID: string, field: FieldTableDto, partnerId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TableLiteDto>>;
    public createFieldUsingPOST(xDataStoreID: string, field: FieldTableDto, partnerId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TableLiteDto>>;
    public createFieldUsingPOST(xDataStoreID: string, field: FieldTableDto, partnerId?: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling createFieldUsingPOST.');
        }

        if (field === null || field === undefined) {
            throw new Error('Required parameter field was null or undefined when calling createFieldUsingPOST.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }
        if (partnerId !== undefined && partnerId !== null) {
            headers = headers.set('X-PARTNER-ID', String(partnerId));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<TableLiteDto>(`${this.basePath}/api/structure/table/fields`,
            field,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Créer une nouvelle table
     * Cette requête permet de créer une nouvelle table.
     * @param xDataStoreID X-DataStoreID
     * @param table table
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createTableUsingPOST(xDataStoreID: string, table: TableLiteDto, partnerId?: string, observe?: 'body', reportProgress?: boolean): Observable<TableLiteDto>;
    public createTableUsingPOST(xDataStoreID: string, table: TableLiteDto, partnerId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TableLiteDto>>;
    public createTableUsingPOST(xDataStoreID: string, table: TableLiteDto, partnerId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TableLiteDto>>;
    public createTableUsingPOST(xDataStoreID: string, table: TableLiteDto, partnerId?: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling createTableUsingPOST.');
        }

        if (table === null || table === undefined) {
            throw new Error('Required parameter table was null or undefined when calling createTableUsingPOST.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }
        if (partnerId !== undefined && partnerId !== null) {
            headers = headers.set('X-PARTNER-ID', String(partnerId));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<TableLiteDto>(`${this.basePath}/api/structure/table`,
            table,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Supprime un datastore
     * Supprime un tenant:&lt;br&gt; - Base de données MySql&lt;br&gt; - Base de données Mongo&lt;br&gt; - dmp&gt;datastore&gt;{item}&lt;br&gt; - identifiant des bases Mongo et MySql&lt;br&gt;
     * @param xDataStoreID X-DataStoreID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteDatastoreUsingDELETE1(xDataStoreID: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public deleteDatastoreUsingDELETE1(xDataStoreID: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public deleteDatastoreUsingDELETE1(xDataStoreID: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public deleteDatastoreUsingDELETE1(xDataStoreID: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling deleteDatastoreUsingDELETE1.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [];

        return this.httpClient.delete<any>(`${this.basePath}/api/structure/datastores`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Supprime un champ d&#39;une table
     * Cette requête permet de supprimer un champ à d&#39;une table.
     * @param xDataStoreID X-DataStoreID
     * @param fieldCode fieldCode
     * @param codeTable codeTable
     * @param idTable idTable
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteFieldUsingDELETE(xDataStoreID: string, fieldCode: string, codeTable?: string, idTable?: string, partnerId?: string, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public deleteFieldUsingDELETE(xDataStoreID: string, fieldCode: string, codeTable?: string, idTable?: string, partnerId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public deleteFieldUsingDELETE(xDataStoreID: string, fieldCode: string, codeTable?: string, idTable?: string, partnerId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public deleteFieldUsingDELETE(xDataStoreID: string, fieldCode: string, codeTable?: string, idTable?: string, partnerId?: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling deleteFieldUsingDELETE.');
        }

        if (fieldCode === null || fieldCode === undefined) {
            throw new Error('Required parameter fieldCode was null or undefined when calling deleteFieldUsingDELETE.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (codeTable !== undefined && codeTable !== null) {
            queryParameters = queryParameters.set('codeTable', <any> codeTable);
        }
        if (idTable !== undefined && idTable !== null) {
            queryParameters = queryParameters.set('idTable', <any> idTable);
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }
        if (partnerId !== undefined && partnerId !== null) {
            headers = headers.set('X-PARTNER-ID', String(partnerId));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [];

        return this.httpClient.delete<boolean>(`${this.basePath}/api/structure/table/fields/${encodeURIComponent(String(fieldCode))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Supprime une table
     * Cette requête permet de supprimer une table.
     * @param xDataStoreID X-DataStoreID
     * @param codeTable codeTable
     * @param idTable idTable
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteTableUsingDELETE(xDataStoreID: string, codeTable?: string, idTable?: string, partnerId?: string, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public deleteTableUsingDELETE(xDataStoreID: string, codeTable?: string, idTable?: string, partnerId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public deleteTableUsingDELETE(xDataStoreID: string, codeTable?: string, idTable?: string, partnerId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public deleteTableUsingDELETE(xDataStoreID: string, codeTable?: string, idTable?: string, partnerId?: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling deleteTableUsingDELETE.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (codeTable !== undefined && codeTable !== null) {
            queryParameters = queryParameters.set('codeTable', <any> codeTable);
        }
        if (idTable !== undefined && idTable !== null) {
            queryParameters = queryParameters.set('idTable', <any> idTable);
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }
        if (partnerId !== undefined && partnerId !== null) {
            headers = headers.set('X-PARTNER-ID', String(partnerId));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [];

        return this.httpClient.delete<boolean>(`${this.basePath}/api/structure/table`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Liste les datastore
     * Cette requête permet de lister les datastore.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAllDatastoreUsingGET(observe?: 'body', reportProgress?: boolean): Observable<Array<DatastoreDto>>;
    public getAllDatastoreUsingGET(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<DatastoreDto>>>;
    public getAllDatastoreUsingGET(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<DatastoreDto>>>;
    public getAllDatastoreUsingGET(observe: any = 'body', reportProgress = false): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [];

        return this.httpClient.get<Array<DatastoreDto>>(`${this.basePath}/api/structure/datastores`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Obtenir les champs d&#39;une table
     * Cette requête permet d&#39;obtenir tous les champs d&#39;une table.&lt;br&gt;La PK n&#39;est pas listé.
     * @param xDataStoreID X-DataStoreID
     * @param codeTable codeTable
     * @param idTable idTable
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAllFieldForTableNameUsingGET(xDataStoreID: string, codeTable?: string, idTable?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<FieldTableDto>>;
    public getAllFieldForTableNameUsingGET(xDataStoreID: string, codeTable?: string, idTable?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<FieldTableDto>>>;
    public getAllFieldForTableNameUsingGET(xDataStoreID: string, codeTable?: string, idTable?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<FieldTableDto>>>;
    public getAllFieldForTableNameUsingGET(xDataStoreID: string, codeTable?: string, idTable?: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getAllFieldForTableNameUsingGET.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (codeTable !== undefined && codeTable !== null) {
            queryParameters = queryParameters.set('codeTable', <any> codeTable);
        }
        if (idTable !== undefined && idTable !== null) {
            queryParameters = queryParameters.set('idTable', <any> idTable);
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [];

        return this.httpClient.get<Array<FieldTableDto>>(`${this.basePath}/api/structure/table/fields`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Lister toutes les tables
     * Cette requête permet de lister toutes les tables. (code 200)&lt;br&gt;Les valeur que \&quot;X_LANG\&quot; peut prendre sont : EN, FR, IT, DE, NL, ES;
     * @param xDataStoreID X-DataStoreID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAllTablesUsingGET(xDataStoreID: string, observe?: 'body', reportProgress?: boolean): Observable<Array<TableLiteDto>>;
    public getAllTablesUsingGET(xDataStoreID: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<TableLiteDto>>>;
    public getAllTablesUsingGET(xDataStoreID: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<TableLiteDto>>>;
    public getAllTablesUsingGET(xDataStoreID: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getAllTablesUsingGET.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [];

        return this.httpClient.get<Array<TableLiteDto>>(`${this.basePath}/api/structure/tables`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Lit un datastore
     * Cette requête permet de lire un datastore.
     * @param datastore datastore
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getDatastoreUsingGET1(datastore: string, observe?: 'body', reportProgress?: boolean): Observable<DatastoreAdminDto>;
    public getDatastoreUsingGET1(datastore: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DatastoreAdminDto>>;
    public getDatastoreUsingGET1(datastore: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DatastoreAdminDto>>;
    public getDatastoreUsingGET1(datastore: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (datastore === null || datastore === undefined) {
            throw new Error('Required parameter datastore was null or undefined when calling getDatastoreUsingGET1.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [];

        return this.httpClient.get<DatastoreAdminDto>(`${this.basePath}/api/structure/datastores/${encodeURIComponent(String(datastore))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Lister une table par son nom
     * Cette requête permet de chercher une table par son code/id et de traduire ses champs. (code 200)Les valeur que \&quot;X_LANG\&quot; peut prendre sont : EN, FR, IT, DE, NL, ES;
     * @param xDataStoreID X-DataStoreID
     * @param code code
     * @param id id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getTableUsingGET(xDataStoreID: string, code?: string, id?: string, observe?: 'body', reportProgress?: boolean): Observable<TableDto>;
    public getTableUsingGET(xDataStoreID: string, code?: string, id?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TableDto>>;
    public getTableUsingGET(xDataStoreID: string, code?: string, id?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TableDto>>;
    public getTableUsingGET(xDataStoreID: string, code?: string, id?: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getTableUsingGET.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (code !== undefined && code !== null) {
            queryParameters = queryParameters.set('code', <any> code);
        }
        if (id !== undefined && id !== null) {
            queryParameters = queryParameters.set('id', <any> id);
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [];

        return this.httpClient.get<TableDto>(`${this.basePath}/api/structure/table`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Modifier un label d&#39;une table donnée
     * Cette requête permet de modifier un label existant d&#39;une table donnée.
     * @param xDataStoreID X-DataStoreID
     * @param fieldCode fieldCode
     * @param newLabels newLabels
     * @param codeTable codeTable
     * @param idTable idTable
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateFieldLabelUsingPUT(xDataStoreID: string, fieldCode: string, newLabels: any, codeTable?: string, idTable?: string, partnerId?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public updateFieldLabelUsingPUT(xDataStoreID: string, fieldCode: string, newLabels: any, codeTable?: string, idTable?: string, partnerId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public updateFieldLabelUsingPUT(xDataStoreID: string, fieldCode: string, newLabels: any, codeTable?: string, idTable?: string, partnerId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public updateFieldLabelUsingPUT(xDataStoreID: string, fieldCode: string, newLabels: any, codeTable?: string, idTable?: string, partnerId?: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling updateFieldLabelUsingPUT.');
        }

        if (fieldCode === null || fieldCode === undefined) {
            throw new Error('Required parameter fieldCode was null or undefined when calling updateFieldLabelUsingPUT.');
        }

        if (newLabels === null || newLabels === undefined) {
            throw new Error('Required parameter newLabels was null or undefined when calling updateFieldLabelUsingPUT.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (codeTable !== undefined && codeTable !== null) {
            queryParameters = queryParameters.set('codeTable', <any> codeTable);
        }
        if (idTable !== undefined && idTable !== null) {
            queryParameters = queryParameters.set('idTable', <any> idTable);
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }
        if (partnerId !== undefined && partnerId !== null) {
            headers = headers.set('X-PARTNER-ID', String(partnerId));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<any>(`${this.basePath}/api/structure/table/fields/${encodeURIComponent(String(fieldCode))}/label`,
            newLabels,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

/**
     * Modifier le champs description d&#x27;une table donnée
     * Cette requête permet de modifier le champ description d&#x27;une table donnée.
     * @param xDataStoreID
     * @param fieldCode
     * @param body
     * @param idTable
     * @param codeTable
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
public updateFieldDescription(xDataStoreID: string, fieldCode: string, body?: string, idTable?: string, codeTable?: string, partnerId?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
public updateFieldDescription(xDataStoreID: string, fieldCode: string, body?: string, idTable?: string, codeTable?: string, partnerId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
public updateFieldDescription(xDataStoreID: string, fieldCode: string, body?: string, idTable?: string, codeTable?: string, partnerId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
public updateFieldDescription(xDataStoreID: string, fieldCode: string, body?: string, idTable?: string, codeTable?: string, partnerId?: string, observe: any = 'body', reportProgress = false ): Observable<any> {

    if (xDataStoreID === null || xDataStoreID === undefined) {
        throw new Error('Required parameter xDataStoreID was null or undefined when calling updateFieldDescription.');
    }

    if (fieldCode === null || fieldCode === undefined) {
        throw new Error('Required parameter fieldCode was null or undefined when calling updateFieldDescription.');
    }




    let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
    if (idTable !== undefined && idTable !== null) {
        queryParameters = queryParameters.set('idTable', <any>idTable);
    }
    if (codeTable !== undefined && codeTable !== null) {
        queryParameters = queryParameters.set('codeTable', <any>codeTable);
    }

    let headers = this.defaultHeaders;
    if (xDataStoreID !== undefined && xDataStoreID !== null) {
        headers = headers.set('X-DataStoreID', String(xDataStoreID));
    }
    if (partnerId !== undefined && partnerId !== null) {
        headers = headers.set('X-PARTNER-ID', String(partnerId));
    }

    // to determine the Accept header
    const httpHeaderAccepts: string[] = [
    ];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
        headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
        'application/json'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
        headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<any>('put',`${this.basePath}/api/structure/table/fields/${encodeURIComponent(String(fieldCode))}/description`,
        {
            body: body,
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        }
    );
}

    /**
     * Modifier la description d&#39;une table
     * Cette requête permet de modifier une description d&#39;une table.
     * @param xDataStoreID X-DataStoreID
     * @param description description
     * @param codeTable codeTable
     * @param idTable idTable
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateTableDescriptionUsingPUT(xDataStoreID: string, description: string, codeTable?: string, idTable?: string, partnerId?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public updateTableDescriptionUsingPUT(xDataStoreID: string, description: string, codeTable?: string, idTable?: string, partnerId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public updateTableDescriptionUsingPUT(xDataStoreID: string, description: string, codeTable?: string, idTable?: string, partnerId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public updateTableDescriptionUsingPUT(xDataStoreID: string, description: string, codeTable?: string, idTable?: string, partnerId?: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling updateTableDescriptionUsingPUT.');
        }

        if (description === null || description === undefined) {
            throw new Error('Required parameter description was null or undefined when calling updateTableDescriptionUsingPUT.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (codeTable !== undefined && codeTable !== null) {
            queryParameters = queryParameters.set('codeTable', <any> codeTable);
        }
        if (idTable !== undefined && idTable !== null) {
            queryParameters = queryParameters.set('idTable', <any> idTable);
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }
        if (partnerId !== undefined && partnerId !== null) {
            headers = headers.set('X-PARTNER-ID', String(partnerId));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<any>(`${this.basePath}/api/structure/table/description`,
            description,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Modifier les informations d&#x27;une table
     * Cette requête permet de modifier les informations d&#x27;une table.
     * @param body
     * @param xDataStoreID
     * @param id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateTableInfo(body: TableDto, xDataStoreID: string, id: string, partnerId?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public updateTableInfo(body: TableDto, xDataStoreID: string, id: string, partnerId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public updateTableInfo(body: TableDto, xDataStoreID: string, id: string, partnerId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public updateTableInfo(body: TableDto, xDataStoreID: string, id: string, partnerId?: string, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling updateTableInfo.');
        }

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling updateTableInfo.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling updateTableInfo.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (id !== undefined && id !== null) {
            queryParameters = queryParameters.set('id', <any>id);
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }
        if (partnerId !== undefined && partnerId !== null) {
            headers = headers.set('X-PARTNER-ID', String(partnerId));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('put',`${this.basePath}/api/structure/table/info`,
            {
                body: body,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Modifier un label d&#39;une table
     * Cette requête permet de modifier un champ d&#39;une table, suivant la langue passée en paramètre.&lt;br/&gt;Elle prend en paramètre l&#39;identifiant de la table, le nom du champ et la traduction du champ en autres langues.Les valeur que ces derniers peut prendre sont : EN, FR, IT, DE, NL, ES;
     * @param xDataStoreID X-DataStoreID
     * @param newLabels newLabels
     * @param code code
     * @param id id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateTableLabelUsingPUT(xDataStoreID: string, newLabels: any, code?: string, id?: string, partnerId?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public updateTableLabelUsingPUT(xDataStoreID: string, newLabels: any, code?: string, id?: string, partnerId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public updateTableLabelUsingPUT(xDataStoreID: string, newLabels: any, code?: string, id?: string, partnerId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public updateTableLabelUsingPUT(xDataStoreID: string, newLabels: any, code?: string, id?: string, partnerId?: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling updateTableLabelUsingPUT.');
        }

        if (newLabels === null || newLabels === undefined) {
            throw new Error('Required parameter newLabels was null or undefined when calling updateTableLabelUsingPUT.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (code !== undefined && code !== null) {
            queryParameters = queryParameters.set('code', <any> code);
        }
        if (id !== undefined && id !== null) {
            queryParameters = queryParameters.set('id', <any> id);
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }
        if (partnerId !== undefined && partnerId !== null) {
            headers = headers.set('X-PARTNER-ID', String(partnerId));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<any>(`${this.basePath}/api/structure/table/label`,
            newLabels,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }


    /**
     * Lister toutes les tables avec l&#x27;acces pour pour le partner
     *
     * @param xDataStoreID
     * @param X_LANG
     * @param partnerId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getTableAccess(xDataStoreID: string, partnerId: string, observe?: 'body', reportProgress?: boolean): Observable<TablesAcessDTO>;
    public getTableAccess(xDataStoreID: string, partnerId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TablesAcessDTO>>;
    public getTableAccess(xDataStoreID: string, partnerId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TablesAcessDTO>>;
    public getTableAccess(xDataStoreID: string, partnerId: string, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getTableAccess.');
        }

        if (partnerId === null || partnerId === undefined) {
            throw new Error('Required parameter partnerId was null or undefined when calling getTableAccess.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (partnerId !== undefined && partnerId !== null) {
            queryParameters = queryParameters.set('partnerId', <any>partnerId);
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<TablesAcessDTO>('get',`${this.basePath}/api/structure/tables/access`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Mise à jour des acces pour les tables des partner
     *
     * @param body
     * @param xDataStoreID
     * @param partnerId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateTableAccess(body: Array<string>, xDataStoreID: string, partnerId: string, observe?: 'body', reportProgress?: boolean): Observable<TablesAcessDTO>;
    public updateTableAccess(body: Array<string>, xDataStoreID: string, partnerId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TablesAcessDTO>>;
    public updateTableAccess(body: Array<string>, xDataStoreID: string, partnerId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TablesAcessDTO>>;
    public updateTableAccess(body: Array<string>, xDataStoreID: string, partnerId: string, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling updateTableAccess.');
        }

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling updateTableAccess.');
        }

        if (partnerId === null || partnerId === undefined) {
            throw new Error('Required parameter partnerId was null or undefined when calling updateTableAccess.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (partnerId !== undefined && partnerId !== null) {
            queryParameters = queryParameters.set('partnerId', <any>partnerId);
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<TablesAcessDTO>('patch',`${this.basePath}/api/structure/tables/access`,
            {
                body: body,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Exporter une Table sous le format JSON
     * Cette requête permet d&#x27;exporter une table au format JSON.
     * @param code
     * @param xDataStoreID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public exportJson(code: string, xDataStoreID: string, observe?: 'body', reportProgress?: boolean): Observable<Array<string>>;
    public exportJson(code: string, xDataStoreID: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<string>>>;
    public exportJson(code: string, xDataStoreID: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<string>>>;
    public exportJson(code: string, xDataStoreID: string, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (code === null || code === undefined) {
            throw new Error('Required parameter code was null or undefined when calling exportJson.');
        }

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling exportJson.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<string>>('get',`${this.basePath}/api/structure/table/export/json/${encodeURIComponent(String(code))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Exporter une Table sous le format JSON
     * Cette requête permet d&#x27;exporter une table au format JSON.
     * @param code
     * @param xDataStoreID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public exportZip(code: Array<string>, xDataStoreID: string, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public exportZip(code: Array<string>, xDataStoreID: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public exportZip(code: Array<string>, xDataStoreID: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public exportZip(code: Array<string>, xDataStoreID: string, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (code === null || code === undefined) {
            throw new Error('Required parameter code was null or undefined when calling exportZip.');
        }

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling exportZip.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (code) {
            code.forEach((element) => {
                queryParameters = queryParameters.append('code', <any>element);
            })
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Blob>('get',`${this.basePath}/api/structure/table/export/zip`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
                responseType: 'blob' as 'json'
            }
        );
    }

    /**
     * Importer une Table
     * Cette requête permet d&#x27;importer une Table via un JSON.
     * @param body
     * @param xDataStoreID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importFromJson(body: string, xDataStoreID: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public importFromJson(body: string, xDataStoreID: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public importFromJson(body: string, xDataStoreID: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public importFromJson(body: string, xDataStoreID: string, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling importFromJson.');
        }

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling importFromJson.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/api/structure/table/import/json`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Importer une Table
     * Cette requête permet d&#x27;importer des Tables via un ZIP.
     * @param xDataStoreID
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importFromZip(xDataStoreID: string, body?: ImportZipBody, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public importFromZip(xDataStoreID: string, body?: ImportZipBody, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public importFromZip(xDataStoreID: string, body?: ImportZipBody, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public importFromZip(xDataStoreID: string, body?: ImportZipBody, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling importFromZip.');
        }


        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/api/structure/table/import/zip`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
